import { initReactI18next } from "react-i18next";

import i18n from "i18next";

const resources = {
  pt: {
    translation: {
      greeting: "Seja bem-vindo",
      loginButton: "Entrar",
    },
  },
  en: {
    translation: {
      greeting: "Welcome",
      loginButton: "Login",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "pt", // default language
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
